var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem } from "@mui/material";
import { forwardRef } from "react";
export const UiListItem = forwardRef((_a, ref) => {
    var { button } = _a, spreadProps = __rest(_a, ["button"]);
    if (spreadProps.component === "a") {
        delete spreadProps.activeClassName;
        delete spreadProps.toAlt;
    }
    return _jsx(ListItem, Object.assign({ button: button, ref: ref }, spreadProps));
});
//# sourceMappingURL=ui_list_item.js.map